import WarningIcon from "Icons/WarningIcon";
import styled from "styled-components";
import { useTranslationContext } from "../Hooks/useTranslationContext";
import { SmallFieldInput } from "./EditableField";

const Container = styled.div<{ showRedBorder: boolean }>`
  margin: -15px 2em -15px 22px;
  border-radius: 0.2em;
  border: solid transparent 2px;
  padding: 0.5em;
  white-space: nowrap;
  ${({ showRedBorder }) =>
    showRedBorder && `border: solid var(--color-field-point-0-full) 2px;`}
`;

interface TimeLimitInputProps {
  timeLimit?: number;
  handleOnTimeLimitChange: (v: string) => void;
  showErrorMessage: boolean;
  disabled?: boolean;
}

const TimeLimitInput = ({
  timeLimit,
  handleOnTimeLimitChange,
  showErrorMessage,
  disabled,
}: TimeLimitInputProps) => {
  const { t } = useTranslationContext();
  return (
    <Container showRedBorder={showErrorMessage}>
      <SmallFieldInput
        type="text"
        value={timeLimit ? Math.round((timeLimit - 3000) / 1000) : ""}
        onChange={(e) => handleOnTimeLimitChange(e.target.value)}
        isEditing={true}
        disabled={disabled}
      />
      {t.seconds}
      {showErrorMessage && (
        <div>
          <WarningIcon />
          <span>{t["you.must.enter.a.valid.time.limit"]}</span>
        </div>
      )}
    </Container>
  );
};
export default TimeLimitInput;
